import {
  invariant, 
  log, 
  flowToObservable, 
  catchError
} from './utils';

export default class Flow {
  constructor({
    Observable, 
    hub,
    observable=null
  }) {
    this._isGentHubFlow = true;
    this.Observable = Observable;
    this.observable = observable;
    this.hub = hub;
  }

  from(arg) {
    arg = flowToObservable(arg);

    let observable = this.Observable.from(arg);
    return new Flow({
      Observable: this.Observable, 
      hub: this.hub,
      observable
    });
  }

  use(pipe, operator='concatMap') {
    if (typeof pipe == 'string') {
      pipe = this.hub.getPipe(pipe);
    }

    pipe = flowToObservable(pipe);

    let observable = this.observable[operator](pipe);
    return new Flow({
      Observable: this.Observable, 
      hub: this.hub,
      observable
    });
  }

  operator(operator) {
    let self = this;
    return function(...args) {
      let observable = self.observable[operator](...args);
      return new Flow({
        Observable: self.Observable, 
        hub: self.hub,
        observable
      });
    }
  }

  subscribe(a, b, c) {
    if (typeof a === 'object') {
      return this.observable.subscribe({
        next: a.next ? catchError(next) : () => {},
        error: a.error ? catchError(error) : (err) => {
          console.log('uncaught exception:', err);
          throw err;
        },
        complete: a.complete ? catchError(complete) : () => {},
      });
      return;
    }

    return this.observable.subscribe({
      next: a ? catchError(a) : () => {},
      error: b ? catchError(b) : (err) => {
        console.log('uncaught exception:', err);
        throw err;
      },
      complete: c ? catchError(c) : () => {},
    });
  }

  toObservable() {
    return this.observable;
  }
}